export enum AuthRoutes {
  ChangePassword = 'change-password',
  CheckToken = 'check-token',
  GetReassignOptions = 'get-reassign-options',
  GetTeamAdmins = 'get-team-admins',
  LoginAuth0 = 'login-auth0',
  LoginLegacy = 'login-legacy',
  LoginMock0 = 'login-mock0',
  Logout = 'logout',
  NewSession = 'new-session',
  ReadGameStatusChecks = 'read-game-status-checks',
  ReadGameStatuses = 'read-game-statuses',
  ReadGameStatusOverride = 'read-game-status-override',
  RefreshAuthToken = 'refresh-auth-token',
  ResetPassword = 'reset-password',
  SetGameStatusOverride = 'set-game-status-override',
  StartImpersonation = 'start-impersonation',
  ToggleGameStatusChecks = 'toggle-game-status-checks',
  ToggleSuperMode = 'toggle-super-mode',
  UpdateUser = 'update-user',
}
